<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="基本信息">
        <el-descriptions :label-style="{width: '80px'}" :column="1" size="mini" border>
          <el-descriptions-item label="节点ID">
            <el-input :value="id" :disabled="true"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="节点名称">
            <el-input v-model="text"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="节点操作">
            <el-checkbox-group v-model="form.handle_value">
              <el-checkbox @change="onInput" v-for="(item,index) in handle_list" :label="item.name" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="附加操作">
            <el-checkbox-group @change="onInput" v-model="form.additional_value">
              <el-checkbox v-for="(item,index) in additional_list" :label="item.name" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="紧急程度">
            <el-switch @change="onInput"
                       v-model="form.urgency"
                       active-color="#13ce66"
                       inactive-color="#ff4949">
            </el-switch>
          </el-descriptions-item>
          <el-descriptions-item label="提醒方式">
            <el-checkbox-group v-model="form.remind_value">
              <el-checkbox @change="onInput" v-for="(item,index) in remind_list" :label="item.name" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="审批意见">
            <el-switch @change="onInput"
              v-model="form.suggestion"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-descriptions-item>
          <el-descriptions-item label="附件上传">
            <el-switch @change="onInput"
              v-model="form.enclosure"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-descriptions-item>
          <el-descriptions-item label="提交/暂存">
            <el-checkbox @change="onInput" v-model="form.is_submit">提交</el-checkbox>
            <el-checkbox @change="onInput" v-model="form.is_staging">暂存</el-checkbox>
          </el-descriptions-item>
          <el-descriptions-item label="是否必过">
            <el-switch @change="onInput"
                       v-model="form.must_pass"
                       active-color="#13ce66"
                       inactive-color="#ff4949">
            </el-switch>
          </el-descriptions-item>
          <el-descriptions-item label="是否可修改审评人">
            <el-switch @change="onInput"
                       v-model="form.edit_node"
                       active-color="#13ce66"
                       inactive-color="#ff4949">
            </el-switch>
          </el-descriptions-item>
          <el-descriptions-item label="超时设置">
            <el-form label-width="80px">
              <el-form-item label="提醒时间">
                <el-input size="mini" v-model="form.remind_out_time" @input="onInput"></el-input>
              </el-form-item>
              <el-form-item label="超时时间">
                <el-input size="mini" v-model="form.node_out_time" @input="onInput"></el-input>
              </el-form-item>
            </el-form>
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="用户">
        <el-descriptions :label-style="{width: '80px'}" :column="1" size="mini" border>
          <el-descriptions-item label="用户角色">
            <el-select
              v-model="form.user_role_ids"
              @change="onInput"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="请输入角色"
              :remote-method="remoteMethod"
              :loading="loading">
              <el-option
                v-for="item in user_role_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="人数">
            <el-input type="number" size="mini" class="form-input" v-model="form.user_number" autocomplete="off" @change="onInput"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="固定人员">
            <div>
              <el-checkbox @change="onInput" v-model="form.fixed_user_selectable">是否可选择</el-checkbox>
            </div>
            <BpmnSelectUser v-model="form.fixed_user_list" @success="onInput" />
          </el-descriptions-item>
          <el-descriptions-item label="异或">
            <el-radio v-model="form.xor" label="1" @change="onInput">“或”操作</el-radio>
            <el-radio v-model="form.xor" label="2" @change="onInput">“且”操作</el-radio>
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="表单">
        <BpmnForm v-model="form.form_fields" @success="onInput"/>
      </el-tab-pane>
      <el-tab-pane label="抄送">
        <BpmnSelectUser v-model="form.send_copy_user_list" @success="onInput" />
      </el-tab-pane>
      <el-tab-pane label="监听">
        <BpmnMonitor v-model="form.monitor" @success="onInput" />
      </el-tab-pane>
      <el-tab-pane label="扩展">
        <BpmnExtend v-model="form.extend" @success="onInput" />
      </el-tab-pane>
    </el-tabs>
  </div>

</template>
<script>
import Http from "../../common/Http";
import BpmnMonitor from "./components/BpmnMonitor";
import BpmnExtend from "./components/BpmnExtend";
import BpmnDatabase from "./components/BpmnDatabase";
import BpmnSelectUser from "./components/BpmnSelectUser";
import FlowCommon from "../lib/FlowCommon";
import BpmnForm from "./components/BpmnForm";

export default {
  name: 'UserProperty',
  components: {BpmnForm, BpmnSelectUser, BpmnDatabase, BpmnExtend, BpmnMonitor},
  props: {
    nodeData: Object,
    lf: Object || String,
  },
  mounted() {
    this.onInit()
    this.remoteMethod('');
  },
  data() {
    return {
      id:"",
      text:"",
      form: FlowCommon.getNodeDefaultConfig('user').properties,
      loading:false,
      user_role_list:[],
      handle_list:[
        {name: "同意",value:"1"},
        {name: "拒绝",value:"2"},
        {name: "重填",value:"3"},
        {name: "退回某步",value:"4"},
      ],
      additional_list:[
        {name: "内部会签",value:"1"},
        {name: "委托处理",value:"2"},
      ],
      remind_list:[
        {name: "及时消息",value:"1"},
        {name: "电子邮件",value:"2"},
        {name: "手机短信",value:"3"},
        {name: "企业微信",value:"4"},
      ]
    }
  },
  watch:{
    text(n){
      const nodeData = this.$props.nodeData
      this.$props.lf.updateText(nodeData.id, n);
    }
  },
  methods: {
    onInit(){
      const { properties,text,id } = this.$props.nodeData
      this.id=id;
      this.text=(text||{}).value||"";
      if (properties) {
        console.log(properties)
        this.$data.form = Object.assign({}, this.$data.form, properties)
      }
    },
    remoteMethod(query){
      const that = this;
      let where={};
      query&&(where.name=query);
      that.loading=true;
      Http.get("flow/UserRole/getList",{
        where:JSON.stringify(where),
        field:"id,name",
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.user_role_list=res.data.list
        }
        that.loading=false;
      })
    },
    onInput(){
      const that = this;
      const nodeData = that.$props.nodeData
      nodeData.properties = that.$data.form
      that.form.user_role_names=that.user_role_list.filter(ret=>{
        return that.form.user_role_ids.indexOf(ret.id)!==-1;
      }).map(ret=>{ return ret.name })
      that.$props.lf.setProperties(nodeData.id, that.$data.form);
    },
    onSubmit() {

    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/PropertySetting/UserProperty.vue